<template>
	<transition name="fade" v-if="config.show">
		<div class="modal-box">
			<div class="modal p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">시험문항</h2>
					<a class="close" @click="$emit('close')">&times;</a>
				</div>
				<div class="modal-body p-15" style="min-height: 1px;">
					<div class="input-group f-16 clearfix">
						{{parseExamCategory(config.examItem.examCategoryId)}}
					</div>
					<div class="bg-lightgray round p-15 m-t-15">
						<div class="input-group full-width m-b-15 p-b-10 b-b">
							<span class="input-group-addon w100 v-mid p-r-5">
								｜ {{config.examItem.type}} ｜
							</span>
							<span class="input-group-addon v-mid text-left p-r-5">
								{{config.examItem.itemName}}
							</span>
						</div>
						<div v-for="(choice) in config.choiceList" :key="choice.examItemId">
							<div class="input-group full-width m-b-10">
								<span class="input-group-addon w60 v-mid p-r-5">
									<input id="table-check3" class="checkbox4" type="checkbox" :checked="config.examItem.cnsr == 1">
									<label for="table-check3" class="sq">체크버튼</label>
								</span>
								<span class="input-group-addon text-left v-mid p-r-5">
									{{choice.itemName}}
								</span>
							</div>
							<div v-show="choice.type == '작성보기'" class="input-group full-width m-b-10">
								<span class="input-group-addon w60 v-mid p-r-5">
								</span>
								<span class="input-group-addon v-mid p-r-5">
									<div class="examImg m-b-15">
										<img src="http://placehold.it/200x100" alt="">
									</div>
								</span>
								<span class="input-group-addon w60 v-mid p-r-5">
								</span>
								<span class="input-group-addon w80 v-mid">
								</span>
							</div>
						</div>
					</div>
				</div>

				<div class="modal-footer p-15 m-t-10 clearfix">
					<button @click="removeItem" class="btn btn-red round pull-left" type="button">삭제</button>
					<button @click="modifyItem" class="btn btn-blue round pull-right" type="button">수정</button>
					<button @click="$emit('close')" class="btn btn-blue round pull-right m-r-5" type="button">확인</button>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import server from '../statics/server'
import _ from 'lodash'
export default {
	name: "ModalExamDetail",

	default: function() {
		return {
			exam_category_list : '',
			examItem : '',
			choiceList : '',
			name: this.name,
			show: false
		}
	},

	props: {
		config: Object
	},
	data (){
		return {
			exam_category_list : this.config.exam_category_list
		}
	},
	methods: {
		parseExamCategory(examCategoryId){
			const self = this;
			let parentsId = examCategoryId;
			let category_name = [];
			for(var i=0; i < 3; i++){
				if(_.find(self.exam_category_list, {examCategoryId : parentsId})){
					category_name.push(_.find(self.exam_category_list, {examCategoryId : parentsId}).name);
					parentsId = _.find(self.exam_category_list, {examCategoryId : parentsId}).parentsId;
				}
				if(parentsId == 0) break;
			}
			return _.reverse(category_name).join(' > ');
		},
		getList (db_name, list_name, config_option){
			// select_name : 선택 분류, parentsId_val : 검색할 카테고리 아이디 list_name : 갱신 할 리스트 명
			const self = this;
			let config = config_option || {}
			server.postAxios(db_name, config, ({data , err}) => {
				err;
				self[list_name] = data.list
			});
		},
		modifyItem(){
			this.$emit('modifyItem', this.config.examItem);
			this.config.show = false;
		},
		removeItem(){
			this.$emit('removeItem', this.config.examItem );
		}
	},
}
</script>